/** Design tokens shared by the fleet interface and its state language. */
export const tokens = {
  status: ["healthy", "warning", "critical", "stale", "offline"],
  motion: { instant: 100, micro: 180, standard: 320 },
  breakpoint: { wide: "64rem" },
  chart: { width: 640, height: 240, padding: 24, viewBoxSize: 100, center: 50, totalLabelY: 48, descriptorLabelY: 61, radius: 42, circumference: 264 },
  map: { markerRadius: 4, clusterRadius: 7 },
} as const satisfies {
  status: readonly string[];
  motion: Readonly<Record<string, number>>;
  breakpoint: Readonly<Record<string, string>>;
  chart: Readonly<Record<string, number>>;
  map: Readonly<Record<string, number>>;
};
